.header { padding: var(--space-7) 0 var(--space-5); }
.eyebrow { font-family: var(--font-display); text-transform: uppercase; letter-spacing: 0.18em; font-size: var(--step--1); color: var(--accent-strong); margin-bottom: var(--space-2); }
.title { font-size: var(--step-3); }
.lead { color: var(--muted); font-size: var(--step-1); max-width: 60ch; }
